interface IndexItem {
  emoji: string;
  title: string;
  count: string;
  desc: string;
}

const indexItems: IndexItem[] = [
  {
    emoji: '🌟',
    title: '明星恋情爆料合集',
    count: '36 条',
    desc: '顶流恋情、秘密约会、官宣分手，娱乐圈感情动态一网打尽',
  },
  {
    emoji: '🎬',
    title: '综艺节目翻车实录',
    count: '28 条',
    desc: '录制事故、嘉宾冲突、剪辑争议，综艺台前幕后全揭秘',
  },
  {
    emoji: '📱',
    title: '网红塌房全纪录',
    count: '42 条',
    desc: '偷税漏税、人设崩塌、虚假宣传，网红圈地震级大瓜合集',
  },
  {
    emoji: '🎵',
    title: '音乐圈内幕爆料',
    count: '19 条',
    desc: '选秀黑幕、假唱风波、版权纠纷，音乐行业不为人知的真相',
  },
  {
    emoji: '💼',
    title: '娱乐圈商业版图',
    count: '23 条',
    desc: '明星投资、品牌代言翻车、商业纠纷，资本视角下的娱乐圈',
  },
  {
    emoji: '🏃',
    title: '体育圈跨界大瓜',
    count: '15 条',
    desc: '运动员恋情、退役内幕、赛事争议，体育圈也有吃不完的瓜',
  },
  {
    emoji: '🎭',
    title: '影视剧拍摄秘闻',
    count: '31 条',
    desc: '替身受伤、剧组矛盾、演员不和，大银幕背后的真实故事',
  },
  {
    emoji: '🗣️',
    title: '名嘴主持人争议录',
    count: '17 条',
    desc: '后台耍大牌、直播翻车、言论争议，主持人的另一面',
  },
  {
    emoji: '🌐',
    title: '海外娱乐新鲜瓜',
    count: '25 条',
    desc: '韩娱、欧美、日娱最新爆料，全球吃瓜无国界',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            爆料合集
          </h2>
          <p className="text-sm text-foreground-500">
            按主题分类浏览，快速找到你最感兴趣的吃瓜方向
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.title}
              className="bg-background-100 rounded-xl border border-background-200/70 p-5 flex items-start gap-4 cursor-pointer hover:border-accent-300/60 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-lg flex-shrink-0">
                {item.emoji}
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-foreground-800 truncate">
                    <strong>{item.title}</strong>
                  </h3>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap flex-shrink-0">
                    {item.count}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}